import { EMAIL_REGEX, PHONE_REGEX, STRONG_PASSWORD_REGEX } from "../Constant/Regex";

export const UserValidationScheema = (json, isEditMode) => {



    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

        if (json?.name === undefined || json?.name === '') {

            Object.assign(errorJson, { name: "Full name cannot be empty *" });
        }

        if (json?.email === undefined || json?.email === '') {
            Object.assign(errorJson, { email: "Field can't be empty *" });
        }
        if (json?.email?.length > 0) {
            if (!EMAIL_REGEX.test(json.email)) {
                Object.assign(errorJson, { email: "Invalid Email Address *" })
            }
        }
        if (json?.phone === undefined || json?.phone === '') {
            Object.assign(errorJson, { phone: "Field can't be empty *" });
        }
        if (json?.phone?.length > 0) {
            if (!PHONE_REGEX.test(json.phone)) {
                Object.assign(errorJson, { phone: "Invalid contact no *" })
            }
        }

        if (json?.roleId === undefined || json?.roleId === '') {
            Object.assign(errorJson, { roleId: "Role selection is required *" });
        }
         if (json?.accountId === undefined || json?.accountId === '') {
            Object.assign(errorJson, { accountId: "Account selection is required *" });
        }
   
        if (!isEditMode) {
            if (json?.password === undefined || json?.password === '') {
                Object.assign(errorJson, { password: "Password is required *" });
            } else if (!STRONG_PASSWORD_REGEX.test(json.password)) {
                Object.assign(errorJson, {
                    password: "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character (@$!%*?&) *"
                });
            }
        }

        resolve(errorJson);
    })
    return MyPromise;
}

